import React from "react";
import './home.css';
import { useState} from "react";
import Header from "../Header/header";
import Dashboard from "../../assets/dashboard.png";
import CaseManager from "../../assets/clinical_notes.png";
import IncidentDetails from "../../assets/info.png";
import Dashboard1 from "../../assets/dashboard_color.png";
import CaseManager1 from "../../assets/clinical_notes_color.png";
import Incident from "../incident-details/incident";
import CaseManagerData from "../case-manager/case-manager";
import DashboardMain from "../dashboard/dashboard";
import User from "../../assets/user3.png";
import UserColor from "../../assets/user4.png"
import UserDetails from "../user-details/user-details";
import Users from "../../assets/users.png";
import Users1 from "../../assets/users_blue.png";
import Chat from "../../assets/chat.png";
import Chat1 from "../../assets/chat_blue.png";
import AllUsers from "../all-users/all-users";
import Tenant from "../tenant-onboarding/tenant";
import Stepup from "../stepup/stepup";

const SidebarData1 = [
{
    icon: Dashboard,
    activeIcon: Dashboard1,
    heading: "Dashboard",
},
{
    icon: CaseManager,
    activeIcon:CaseManager1,
    heading: "Case Manager",
},
{
    icon: IncidentDetails ,
    activeIcon: IncidentDetails,
    heading: "Incident Details",
},
{
  icon: CaseManager,
  activeIcon:CaseManager1,
  heading: "Stepup",
},
{
  icon: User,
  activeIcon: UserColor,
  heading: "User Details"
}

];
const SidebarData2 = [
  {
      icon: Users,
      activeIcon: Users1,
      heading: "Users",
  },
  {
      icon: Chat,
      activeIcon:Chat1,
      heading: "Tenant Onboarding",
  },
  
  ];


  function Home(props){
    const {userType , onLogout} = props;
    const [selected,setSelected] = useState(0);
    const [selectedIncident, setSelectedIncident] = useState(null);
    
    const [selected1,setSelected1] = useState();
    const [selected2,setSelected2] = useState();
    const chooseMessage =(selected1,selected2)=>{
      setSelected1(selected1)
      setSelected2(selected2)
    }

    const [searchTerm, setSearchTerm] = useState('');

    const handleIncidentClick = (incident) => {
    setSelectedIncident(incident);
    setSelected(2); 
    };

    const handleSearch = (value) => {
      setSearchTerm(value.toLowerCase());
    };
 
    return (
        <div className="main-container d-flex flex-column">
        <Header userType={userType}  chooseMessage={chooseMessage} onLogout = {onLogout} onSearch={handleSearch}/>
            {userType === "super_admin" ? (
              <div className="body-container d-flex flex-row">
                <div className="left d-flex flex-column" >
                 {SidebarData2.map((item, index) => {
                    return (
                      <div className={selected === index ? 'active d-flex flex-row align-items-center' : 'option d-flex flex-row align-items-center'}
                        key={index}
                        onClick={() => setSelected(index)}>
                        <img src={selected === index ? item.activeIcon : item.icon} height="20px" width="20px" alt="icon" />
                        <span>{item.heading}</span>
                      </div>
                    )
                    })}
                  </div>
                  <div className="right">
                    {selected === 0 && <AllUsers onLogout = {onLogout}/>}
                    {selected === 1 && <Tenant/>}
                  </div>
               </div>
            ) : (
            <div className="body-container d-flex flex-row">
              <div className="left d-flex flex-column">
                {SidebarData1.map((item, index) => {
                  return (
                    <div className={selected === index ? 'active d-flex flex-row align-items-center' : 'option d-flex flex-row align-items-center'}
                      key={index}
                      onClick={() => setSelected(index)}>
                      <img src={selected === index ? item.activeIcon : item.icon} height="20px" width="20px" alt="icon" />
                      <span>{item.heading}</span>
                    </div>
                  )
                  })}
                </div>
                <div className="right">
                  {selected === 0 && <DashboardMain selected1={selected1} selected2={selected2} onLogout={onLogout}/>}
                  {selected === 1 && <CaseManagerData selected1={selected1} selected2={selected2} onLogout={onLogout} onIncidentClick={handleIncidentClick} searchTerm={searchTerm}/>}
                  {selected === 2 && <Incident selectedIncident={selectedIncident} onLogout={onLogout} />}
                  {selected === 3 && <Stepup selected1={selected1} selected2={selected2} searchTerm={searchTerm}/>}
                  {selected === 4 && <UserDetails searchTerm={searchTerm} onLogout={onLogout}/>}
                </div>
            </div>
          )}
        </div>
      );
}

export default Home;